<template>
    <el-row :gutter="20">
        <el-col :md="24" :sm="24" class="mb-3">
            <el-card class="profile" shadow="never">
                <div slot="header" class="clearfix">
                    <div class="mb-3">使用统计<span class="ml-3"></span></div>
                    <el-form :inline="true" :model="search" class="report-form-inline">
                        <el-form-item label="选择时间">
                            <el-select v-model="search.short_cut" @change="handleCalculate">
                                <el-option label="六个月内" :value="6"></el-option>
                                <el-option label="一年内" :value="12"></el-option>
                                <el-option label="两年内" :value="24"></el-option>
                                <el-option label="三年内" :value="36"></el-option>
                                <el-option label="所有时间" :value="0"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="">
                            <el-checkbox v-model="search.select_date"></el-checkbox>
                        </el-form-item>
                        <el-form-item label="起始日期">
                            <el-date-picker value-format="yyyy-MM-dd" :disabled="!search.select_date" type="date"
                                            placeholder="选择起始日期" v-model="search.begin_date"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="结束日期">
                            <el-date-picker value-format="yyyy-MM-dd" :disabled="!search.select_date" type="date"
                                            placeholder="选择结束日期" v-model="search.end_date"></el-date-picker>
                        </el-form-item>

                        <el-form-item>
                            <el-button type="primary" @click="handleCalculate"><i class="el-icon-refresh"></i> 计算
                            </el-button>
                        </el-form-item>

                        <el-form-item>
                            <el-button type="info" @click="handleDownload" :disabled="!report_date">
                                <i class="el-icon-download"></i> 下载报表[ <i class="text-danger" v-if="events.error.error">{{ events.error.message }}</i>
                                <span v-if="report_date">{{ report_date }}</span>
                                <span v-if="report_working" > {{ events.status.process }} / {{ events.status.total}}</span>
                                <span v-if="!report_date && !report_working">未生成</span>
                                ]
                            </el-button>
                            <el-button type="primary" @click="handleGenerate" :disabled="report_working"><i
                                class="el-icon-refresh"></i> 生成报表
                            </el-button>
                            <el-dropdown>
                                <el-button type="default" class="ml-2">
                                    更多菜单<i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item @click.native="handleDownloadVisitor">新增用户</el-dropdown-item>
                                    <el-dropdown-item @click.native="handleDownloadFreeRoom">空余会议室
                                    </el-dropdown-item>
                                    <el-dropdown-item @click.native="handleDownloadMeetingList">未来会议清单
                                    </el-dropdown-item>
                                    <el-dropdown-item @click.native="handleDownloadDailyReport">会议每日清单
                                    </el-dropdown-item>
                                    <el-dropdown-item @click.native="handleDownloadUserUsageReport">用户使用清单
                                    </el-dropdown-item>

                                </el-dropdown-menu>
                            </el-dropdown>
                        </el-form-item>

                    </el-form>
                </div>
                <div ref="echarts_content" style="height: 300px;" v-show="!show_table"></div>
                <div v-if="topVisible" class="mt-4 pt-3 border-top" ref="echarts_content_user"
                     style="border-color:#eee;height: 400px;" v-show="!show_table"></div>
                <div v-if="topVisible" class="mt-4 pt-3 border-top" ref="echarts_content_dept"
                     style="border-color:#eee;height: 400px;" v-show="!show_table"></div>
                <div v-if="topVisible" class="mt-4 pt-3 border-top" ref="echarts_content_usage"
                     style="border-color:#eee;height: 400px;" v-show="!show_table"></div>
                <div v-if="topVisible" class="mt-4 pt-3 border-top" ref="echarts_content_visitor"
                     style="border-color:#eee;height: 400px;" v-show="!show_table"></div>
                <div v-if="topVisible" class="mt-4 pt-3 border-top" ref="echarts_room_usage"
                     style="border-color:#eee;height: 400px;" v-show="!show_table"></div>

                <div v-show="show_table" ref="excel_table">
                    <el-table border size="small"
                              :data="table.data" show-summary
                              style="width: 100%">
                        <el-table-column v-for="header in table.headers" :key="header.prop"
                                         :prop="header.prop"
                                         :label="header.label">
                        </el-table-column>
                    </el-table>
                </div>
            </el-card>
        </el-col>
    </el-row>

</template>

<script>

import echarts from "echarts"
import {mapState, mapMutations} from "vuex";
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
import SseMixin from "@/common/mixins/sse-mixin";


export default {
    name: "statistic",
    mixins: [SseMixin],
    data() {
        return {
            report_date: null,
            report_working: false,
            search: {
                begin_date: '',
                end_date: '',
                select_date: false,
                short_cut: 6,
            },
            my_charts: null,
            user_charts: null,
            dept_charts: null,
            usage_charts: null,
            visitor_charts: null,
            room_usage_charts: null,
            show_table: false,
            table: {headers: [], data: []},
            timer: 0,
        }
    },
    computed: {
        ...mapState(['user', 'process']),
        topVisible() {
            const level = parseInt(this.user.role_level);
            return level > 2;
        }
    },
    mounted() {
        this.my_charts = echarts.init(this.$refs['echarts_content']);
        if (this.topVisible) {
            this.user_charts = echarts.init(this.$refs['echarts_content_user']);
            this.dept_charts = echarts.init(this.$refs['echarts_content_dept']);
            this.usage_charts = echarts.init(this.$refs['echarts_content_usage']);
            this.visitor_charts = echarts.init(this.$refs['echarts_content_visitor']);
            this.room_usage_charts = echarts.init(this.$refs['echarts_room_usage']);

        }
        this.handleCalculate();
        this.getReportDate();
    },
    methods: {
        ...mapMutations('user', ['setUserInfo']),
        getReportDate() {
            this.$api('Report.Statistic.status', this.search, true).then((res) => {
                const data = res.data.data;
                this.report_date = data.time;
            });
        },
        handleGenerate() {
            this.report_date = null;
            this.report_working = true;
            this.connectSSE('Report.Statistic.Generate',this.search,this.afterSse);
        },
        afterSse() {
            if (this.events.error.error) { // 如果有错误，提示错误
                this.$notice.error(this.events.error.message);
            } else {
                if (this.events.status.time) {
                    this.report_date = this.events.status.time;
                } else {
                    this.getReportDate();
                }
            }
            this.report_working = false;

        },
        handleDownload() {
            this.$api('Report.Statistic.Download', this.search, true).then((res) => {
                const data = res.data.data;
                this.table.headers = data.headers;
                this.table.data = data.data;
                //this.show_table = true;
                this.$nextTick(function () {
                    this.exportExcel('会议使用表');
                })
            });
        },
        handleDownloadVisitor() {
            this.$api('Report.Statistic.UserTrail', this.search, true).then((res) => {
                const data = res.data.data;
                this.table.headers = data.headers;
                this.table.data = data.data;
                //this.show_table = true;
                this.$nextTick(function () {
                    this.exportExcel('新增用户表');
                })
            });
        },
        handleDownloadFreeRoom() {
            this.$api('Report.Statistic.FreeRoom', this.search, true).then((res) => {
                const data = res.data.data;
                this.table.headers = data.headers;
                this.table.data = data.data;
                //this.show_table = true;
                this.$nextTick(function () {
                    this.exportExcel('空闲会议室表');
                })
            });
        },
        handleDownloadMeetingList() {
            this.$api('Report.Statistic.MeetingList', this.search, true).then((res) => {
                const data = res.data.data;
                this.table.headers = data.headers;
                this.table.data = data.data;
                //this.show_table = true;
                this.$nextTick(function () {
                    this.exportExcel('未来会议清单');
                })
            });
        },
        handleDownloadDailyReport() {
            this.$api('Report.Statistic.DailyReport', this.search, true).then((res) => {
                const data = res.data.data;
                this.table.headers = data.headers;
                this.table.data = data.data;
                //this.show_table = true;
                this.$nextTick(function () {
                    this.exportExcel('会议每日清单');
                })
            })
        },
        handleDownloadUserUsageReport() {
            this.$api('Report.Statistic.UserUsageReport', this.search, true).then((res) => {
                const data = res.data.data;
                this.table.headers = data.headers;
                this.table.data = data.data;
                //this.show_table = true;
                this.$nextTick(function () {
                    this.exportExcel('用户会议使用量清单');
                })
            })
        },
        // 导出表格
        exportExcel(name) {
            /* generate workbook object from table */
            let wb = XLSX.utils.table_to_book(this.$refs['excel_table'], {raw: true});
            /* get binary string as output */
            let wbout = XLSX.write(wb, {bookType: 'xlsx', bookSST: true, type: 'array'});
            let now = new Date().Format('yyyy-MM-dd');
            try {
                FileSaver.saveAs(new Blob([wbout], {type: 'application/octet-stream'}), `${name}-${now}.xlsx`)
            } catch (e) {
                console.log(e, wbout)
            }
            return wbout
        },
        handleCalculate() {
            this.calStatistic();
            if (this.topVisible) {
                this.calTop();
            }
            this.show_table = false;
        },
        calStatistic() {
            this.$api('Report.Statistic.Get', this.search, true).then((res) => {
                const data = res.data.data;

                let option = {
                    title: {text: '视频会议使用统计表'},
                    tooltip: {},
                    xAxis: {
                        data: data.xAxis,
                        axisLabel: {
                            interval: 0,
                            rotate: 40
                        }
                    },
                    yAxis: {},
                    series: [],
                    legend: {
                        data: data.legend
                    },
                    toolbox: {
                        show: true,
                        feature: {
                            magicType: {show: true, type: ['line', 'bar']},
                            saveAsImage: {show: true}
                        }
                    },
                };
                for (let item in data.series) {
                    const raw = data.series[item];
                    const keys = Object.keys(raw);
                    let flat = keys.map(item => raw[item]);

                    option.series.push({
                        name: item,
                        type: 'bar',
                        data: flat,
                        label: {
                            normal: {
                                show: true,
                                position: 'top',
                                formatter: function (params) {
                                    return (params.value > 0 ? params.value : '');
                                }
                            },
                        },
                    })
                }
                this.my_charts.setOption(option);
            })

        },
        calTop() {
            this.$api('Report.Statistic.Top', this.search, true).then((res) => {
                const data = res.data.data;
                const user = data['user'];
                const dept = data['department'];
                const usage = data['usage'];
                const usage_names = usage.names.map(function (i) {
                    return i == null ? '未指定' : i;
                });
                let option = {
                    title: [
                        {text: '用户会议次数 TOP 10', x: '0%',},
                        {text: '用户会议时间 TOP 10', x: '50%',}],
                    tooltip: {
                        trigger: 'item',
                        formatter: "{a} <br/>{b} : {c} ({d}%)"
                    },
                    toolbox: {
                        show: true,
                        feature: {
                            saveAsImage: {show: true}
                        }
                    },
                    legend: {
                        data: user.names,
                        top: 'bottom'
                    },
                    series: [{
                        type: 'pie',
                        radius: [20, 110],
                        center: ['25%', '50%'],
                        data: this.makeData(user.numbers, user.names),
                        name: '次数',
                        label: {
                            formatter: '{b}:{c}'
                        }
                    }, {
                        type: 'pie',
                        radius: [30, 110],
                        center: ['75%', '50%'],
                        data: this.makeData(user.totals, user.names),
                        name: '时间(小时)',
                        label: {
                            formatter: '{b}:{c}'
                        }
                    }],

                };

                let option2 = {
                    title: [
                        {text: '部门会议次数 TOP 10', x: '0%',},
                        {text: '部门会议时间 TOP 10', x: '50%',}],
                    tooltip: {
                        trigger: 'item',
                        formatter: "{a} <br/>{b} : {c} ({d}%)"
                    },
                    toolbox: {
                        show: true,
                        feature: {
                            saveAsImage: {show: true}
                        }
                    },
                    legend: {
                        data: dept.names,
                        top: 'bottom'
                    },
                    series: [{
                        type: 'pie',
                        radius: [20, 110],
                        center: ['25%', '50%'],
                        data: this.makeData(dept.numbers, dept.names),
                        name: '次数',
                        label: {
                            formatter: '{b}:{c}'
                        }
                    }, {
                        type: 'pie',
                        radius: [30, 110],
                        center: ['75%', '50%'],
                        data: this.makeData(dept.totals, dept.names),
                        name: '时间(小时)',
                        label: {
                            formatter: '{b}:{c}'
                        }
                    }],
                };

                let option3 = {
                    title: [
                        {text: '用途次数 TOP 10', x: '0%',},
                        {text: '用途时间 TOP 10', x: '50%',}],
                    tooltip: {
                        trigger: 'item',
                        formatter: "{a} <br/>{b} : {c} ({d}%)"
                    },
                    toolbox: {
                        show: true,
                        feature: {
                            saveAsImage: {show: true}
                        }
                    },
                    legend: {
                        data: usage_names,
                        top: 'bottom'
                    },
                    series: [{
                        type: 'pie',
                        radius: [20, 110],
                        center: ['25%', '50%'],
                        data: this.makeData(usage.numbers, usage_names),
                        name: '次数',
                        label: {
                            formatter: '{b}:{c}'
                        }
                    }, {
                        type: 'pie',
                        radius: [30, 110],
                        center: ['75%', '50%'],
                        data: this.makeData(usage.totals, usage_names),
                        name: '时间(小时)',
                        label: {
                            formatter: '{b}:{c}'
                        }
                    }],
                };

                this.user_charts.setOption(option);
                this.dept_charts.setOption(option2);
                this.usage_charts.setOption(option3);

            });

            this.$api('Report.Statistic.UserTrail', {short_cut: 1}, true).then((res) => {
                const data = res.data.data;
                const axis = data.data.map(i => i.date);
                const numbers = data.data.map(i => i.number);
                let option = {
                    title: {text: '30日用户新增表'},
                    tooltip: {},
                    xAxis: {
                        data: axis,
                        axisLabel: {
                            interval: 0,
                            rotate: 40
                        }
                    },
                    yAxis: {},
                    toolbox: {
                        show: true,
                        feature: {
                            magicType: {show: true, type: ['line', 'bar']},
                            saveAsImage: {show: true}
                        }
                    },
                    series: [{
                        name: '30日用户新增表',
                        type: 'bar',
                        data: numbers,
                        label: {
                            normal: {
                                show: true,
                                position: 'top',
                                formatter: function (params) {
                                    return (params.value > 0 ? params.value : '');
                                }
                            },
                        },
                    }]
                };

                this.visitor_charts.setOption(option);
            });

            this.$api('Report.Statistic.RoomUsage', {}, true).then((res) => {
                console.log(res);
                const data = res.data.data;
                const axis = data.headers;

                let option = {
                    color: ['#c23531', '#ffbcbc', '#38c26e', '#bcffc7',
                        '#38b6c2', '#bcfeff', '#387bc2', '#bce2ff',
                        '#5f38c2', '#d3bcff', '#c29938', '#ffebbc'],
                    title: {text: '会议室使用情况'},
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                        }
                    },
                    xAxis: {
                        data: axis,
                        axisLabel: {
                            interval: 0,
                            rotate: 40
                        }
                    },
                    yAxis: {type: 'value'},
                    toolbox: {
                        show: true,
                        feature: {
                            magicType: {show: true, type: ['line', 'bar']},
                            saveAsImage: {show: true}
                        }
                    },
                    series: []
                };

                for (let i in data.data) {
                    const item = data.data[i];
                    option.series.push({
                        name: item.name + '已用',
                        type: 'bar',
                        stack: item.name,
                        areaStyle: {},
                        data: item.used
                    });
                    option.series.push({
                        name: item.name + '未用',
                        type: 'bar',
                        stack: item.name,
                        areaStyle: {},
                        data: item.free
                    })

                }

                this.room_usage_charts.setOption(option);
            });
        },

        makeData(value, name) {
            let ret = [];
            for (let i = 0; i < value.length; i++) {
                ret.push({value: value[i], name: name[i]});
            }
            return ret;
        }
    },
    created() {
        let d = new Date();
        this.search.end_date = d.Format('yyyy-MM-dd');
        d.setDate(1);
        this.search.begin_date = d.Format('yyyy-MM-dd');
    }
}
</script>

<style scoped lang="scss">

.report-form-inline {
    .el-form-item {
        margin-bottom: 0;
    }
}


</style>
